import React from "react";
import PropTypes from "prop-types";

const ConfidentialityPolicy = () => {

  const introText =
    "All clients are covered under the Federal Law of confidentiality as stated in (42CFR Part 2) and in the F.S. 397.419(7), 397.451(10), 397.501(7), 397.6751(2)(a)(c) and 397.752.";

  const bulletItems = [
    "Legacy Healing Center Margate, LLC will not disclose any information to anyone unless the following conditions exist:",
    "It is a crime for either or both the program its staff and the client to divulge information in group settings. All information discussed or revealed in group, meetings, housing, including identifying any individual therein or subject matter thereof, is protected by law.",
    "Federal Law does not protect information on the following (these will be reported):",
    "This policy is NOT sufficient for the release of any information concerning the HIV status of any client unless a separate release of information is obtained that specifically gives permission to release HIV information.",
  ];

  const numberedItems = [
    "The client consents in writing",
    "The disclosure is allowed by a court order signed by a judge; or",
    "The disclosure is made to medical personnel or to a qualified person for research, audit or program evaluation.",
    "The disclosure is made to protect self or others or a crime that has been committed.",
    "The disclosure is made to protect self or others of harm to self or others (Duty to Warn- Suicide or Homicide)",
    "The disclosure is made to protect suspected child/elderly abuse and/or neglect",
  ];

  const thirdBulletNumberedItems = [
    "Information about a crime committed by a client at Legacy or against any staff.",
    "Threats of crime or violence",
    "Information concerning suspected child abuse or neglect.",
  ];

  const quoteText =
    '"The enclosed medical/psychiatric/psychological information is released in accordance with Florida Statutes: 90.24, 490.32, and/or 90.503, 458.1 and 394.459(9) and by Federal Law (42CFR Part 2). Federal regulations prohibit any further disclosure of this information without specific written consent of the person to whom it pertains, or as otherwise permitted by such regulations. Federal Law prohibits the use of this information to criminally investigate or process any alcohol or drug abuse treatment client."';

  return (
    <div
      style={{
        fontFamily: "Elef Layla MF",
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
        fontSize: "15pt",
        height: '1200px',
        lineHeight: '1.2'
      }}
    >
      {/* Header */}

      <div style={{ textAlign: "center" }}>
        <h2
          style={{
            display: "inline-block",
            fontSize: "24pt",
            fontFamily: "Elef Layla MF",
            marginBottom: "15px",
             borderBottom: '2px solid black',
             display: 'inline-block'
            
          }}
        >
          CONFIDENTIALITY POLICY
        </h2>
      </div>

      {/* Introduction */}
      <p style={{ marginBottom: "15px",fontFamily: "Elef Layla MF" }}>{introText}</p>

      {/* Procedure Heading */}
      <p
        style={{
          // fontWeight: "bold",
          marginBottom: "10px",
          fontFamily: "Elef Layla MF"
        }}
      >
        Procedure:
      </p>

      {/* Bullet Points */}
      <ul
        style={{
          listStyleType: "none",
          paddingLeft: "45px",
          marginBottom: "15px",
        }}
      >
        {bulletItems.map((item, index) => (
          <li
            key={index}
            style={{ marginBottom: "10px", position: "relative" }}
          >
            <div
              style={{
                position: "absolute",
                left: "-15px",
                top: "6px",
                width: "6px",
                height: "6px",
                border: "1px solid black",
                borderRadius: "50%",
              }}
            ></div>
            <div style={{ paddingLeft: "15px" }}>
              {item}

              {/* Numbered items for first bullet */}
              {index === 0 && (
                <ol style={{ paddingLeft: "20px", marginTop: "15px",marginLeft:"25px" }}>
                  {numberedItems.map((item, numIndex) => (
                    <li key={numIndex} style={{ marginBottom: "5px" }}>
                      {item}
                    </li>
                  ))}
                </ol>
              )}

              {/* Numbered items for third bullet */}
              {index === 2 && (
                <ol style={{ paddingLeft: "20px", marginTop: "15px",marginLeft:"25px" }}>
                  {thirdBulletNumberedItems.map((item, numIndex) => (
                    <li key={numIndex} style={{ marginBottom: "5px" }}>
                      {item}
                    </li>
                  ))}
                </ol>
              )}
            </div>
          </li>
        ))}
      </ul>

      {/* Final paragraph */}
      <p style={{ marginBottom: "10px" }}>
        Any Information released in accordance with this policy must be
        accompanied by the following language:
      </p>

      {/* Block quote */}
      <div>
        {quoteText}
      </div>
    </div>
  );
};

ConfidentialityPolicy.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  })
};

export default ConfidentialityPolicy;
